import React, { useCallback } from "react";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { usePaymentForm } from "../PaymentFormContext";
import Memo from "./Memo";

export default function PaymentScreenMemo() {
  const { dispatch } = usePaymentPage();
  const { state } = usePaymentForm();

  /**
   * NOTE FOR WHEN COPYING
   * These useCallbacks are important.
   * Without them the memo input closes when the user types.
   * */
  const removeMemo = useCallback(() => {
    dispatch({ type: "updateMemo", payload: null });
  }, [dispatch]);

  const updateMemo = useCallback(
    (text) => {
      dispatch({ type: "updateMemo", payload: text });
    },
    [dispatch]
  );

  const memoEnabled =
    window?.data?.paymentPageData?.fund?.paymentPageSettings?.memoEnabled;

  if (!memoEnabled) return null;

  return (
    <Memo
      disabled={state?.isSubmitting}
      onRemoveMemo={removeMemo}
      onUpdateMemo={updateMemo}
      hasHorizontalMargin={true}
    />
  );
}
